export default "__VITE_ASSET__DmirtRpY__"